import { AttributeDef, AttributeKey } from '../types';

/** 属性定义表 */
export const ATTRIBUTE_DEFS: Record<AttributeKey, AttributeDef> = {
    charm: {
        key: 'charm',
        name: '颜值',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    talent: {
        key: 'talent',
        name: '演技',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    temperament: {
        key: 'temperament',
        name: '气质',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    stamina: {
        key: 'stamina',
        name: '体能',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    eq: {
        key: 'eq',
        name: '情商',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    wisdom: {
        key: 'wisdom',
        name: '智慧',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    artistry: {
        key: 'artistry',
        name: '才艺',
        min: 0,
        max: 100,
        startRange: [0, 20],
    },
    reputation: {
        key: 'reputation',
        name: '口碑',
        /**
         * ⚠️ 全库唯一放开负值的属性（2026-10-04 口碑可负批，用户令「只有口碑可以为负，拒载老档」）。
         * 本表按 100 制书写，运行时由 GameData 一次性 ×ATTR_SCALE(=5) ⇒ 实际下限 **-500**、上限 500。
         * 动机：特殊事件（如「资源咖演砸角色被全网骂」）要能**扣穿 0**；旧口径 min 0 让大额负口碑被夹零、砸不动。
         * ⛔ 其他七维跟着放负（用户明令只此一维）；⛔ 在这里直接写 -500（那是运行时值，本表是 100 制）。
         */
        min: -100,
        max: 100,
        startRange: [0, 20],
    },
};

/** 所有属性 key 列表 */
export const ATTRIBUTE_KEYS: AttributeKey[] = ['charm', 'talent', 'temperament', 'stamina', 'eq', 'wisdom', 'artistry', 'reputation'];